import { render, staticRenderFns } from "./AppPotwierdzenieError.vue?vue&type=template&id=6acf075c&"
import script from "./AppPotwierdzenieError.vue?vue&type=script&lang=js&"
export * from "./AppPotwierdzenieError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports